import React from 'react'

import PropTypes from 'prop-types'

import './practice.css'

const Practice = (props) => {
  return (
    <div className="practice-practice">
      <div className="practice-heading">
        <h3 className="practice-header">{props.Title}</h3>
        <p className="practice-caption">{props.Description}</p>
      </div>
      <div className="read-more">
        <span className="practice-text">Read more</span>
        <img alt="image" src="/Icons/arrow-2.svg" className="practice-image" />
      </div>
    </div>
  )
}

Practice.defaultProps = {
  Title:
    'Real-Time Static Hand Gesture Recognition for American Sign Language (ASL) in Complex Background',
  Description:
    'Luego del procesamiento de las imágenes se utiliza la distancia euclidiana minima del vector de caracteristicas para el reconocimiento. El vector de características se forma usando el centroide dado por (Cx, Cy) y el área del borde de la mano.',
}

Practice.propTypes = {
  Title: PropTypes.string,
  Description: PropTypes.string,
}

export default Practice
